<script setup lang="ts">
/**
 * Wrapper local autour de #campaign-ui/CampaignTabContent.vue.
 * Le composant vit dans le package partagé (source unique). Ce wrapper existe
 * pour que l'auto-import Nuxt (qui ne scanne pas node_modules) trouve le
 * composant sous son nom habituel. Karim 2026-06-21.
 */
import CampaignTabContent from "@donoor/ui/campaign/CampaignTabContent.vue";
</script>

<template>
  <CampaignTabContent v-bind="($attrs as any)" />
</template>
